import articleTagsService from '../article-tags/article-tags';
import { localStorage, LocalStorageKeysMapping } from '../local-storage/local-storage';

class DailyNewsSuggestionsManager {
  SUGGESTIONS_NUM = 3;

  getSuggestions(dailyNews) {
    const suggestions = [];

    for (let i = 0; i < dailyNews.length && suggestions.length < this.SUGGESTIONS_NUM; i++) {
      const dailyNewsArticle = dailyNews[i];
      if (!this._isSeenDailyNews(dailyNewsArticle._id)) suggestions.push(dailyNewsArticle);
    }

    return suggestions;
  }

  _isSeenDailyNews(id) {
    const key = `${LocalStorageKeysMapping.SEEN_DAILY_NEWS}_${id}`;
    return localStorage.getItem(key) === 'true';
  }
}

export default DailyNewsSuggestionsManager;